import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: boolean;
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon = false,
  fullWidth = false,
  className = '',
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-none tracking-wide uppercase text-sm md:text-base';
  const variants = {
    primary: 'bg-[#C5A55A] text-white hover:bg-[#B09045] shadow-lg hover:shadow-xl border border-[#C5A55A]',
    secondary: 'bg-[#2D2D2D] text-white hover:bg-[#1A1A1A] shadow-md hover:shadow-lg border border-[#2D2D2D]',
    outline: 'bg-transparent text-[#2D2D2D] border-2 border-[#2D2D2D] hover:bg-[#2D2D2D] hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3',
    lg: 'px-8 py-4 text-lg font-bold'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank');
      return;
    }
    if (scrollTo) {
      e.preventDefault();
      const target = document.getElementById(scrollTo);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]} 
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-129">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-130" />}
    </motion.button>;
}